import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import GatewayPage from './pages/GatewayPage';
import LandingPage from './pages/LandingPage';
import AdminPage from './pages/AdminPage';
import VoicePage from './pages/VoicePage';

export default function App() {
  return (
    <div className="noise-overlay">
      <Router>
        <Routes>
          <Route path="/" element={<GatewayPage />} />
          <Route path="/auto" element={<LandingPage />} />
          <Route path="/voice" element={<VoicePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="top-right" richColors theme="dark" />
      </Router>
    </div>
  );
}
